import toLower from "lodash/toLower";
import React, { useMemo, useRef, useState } from "react";
function InputFileTemplate({ renderComponent, onFileChange, className }) {
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState();
    const startAddFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleFileChange = (event) => {
        const { files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            const fileName = file.name;
            const lastDotIndex = fileName.lastIndexOf(".");
            const nameWithoutExtension = lastDotIndex > 0 ? fileName.substring(0, lastDotIndex) : fileName;
            const extension = lastDotIndex > 0 ? `.${toLower(fileName.substring(lastDotIndex + 1))}` : "";
            const fileData = {
                file,
                fullName: file.name,
                name: nameWithoutExtension,
                type: file.type,
                extension
            };
            setSelectedFile(fileData);
            onFileChange === null || onFileChange === void 0 ? void 0 : onFileChange(fileData);
        }
    };
    const component = useMemo(() => renderComponent({ selectedFile, startAddFile }), [selectedFile, renderComponent]);
    return (React.createElement("div", null,
        React.createElement("div", { className: className }, component),
        React.createElement("input", { type: "file", ref: fileInputRef, onChange: handleFileChange, style: { display: "none" } })));
}
export default InputFileTemplate;
